<ng-container
  *ngFor="let item of phxList; let i = index"
  [ngTemplateOutlet]="phxDragItemTemplate"
  [ngTemplateOutletContext]="{ $implicit: item, index: i }"
></ng-container>
